import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { labelText } from "@cloudpivot/form/src/schema/system-data-item-codes";
import HLabel from "@cloudpivot/form/src/common/components/label.vue";
let Create = class Create extends Vue {
    render(h) {
        return h('h-label', { props: { text: labelText
            } });
    }
};
tslib_1.__decorate([
    Prop()
], Create.prototype, "control", void 0);
Create = tslib_1.__decorate([
    Component({
        name: 'Create',
        components: {
            HLabel: HLabel
        }
    })
], Create);
export default Create;
